import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../provider/authProvider';

/**
 * Admin-Only Route Protection
 * Only allows Admin users to access
 */
export const AdminRoute = ({ children }) => {
    const { token, isAdmin, getCurrentUser } = useAuth();
    
    // Debug logging
    console.log('AdminRoute - Token:', token ? 'present' : 'missing');
    const currentUser = getCurrentUser();
    console.log('AdminRoute - Current User:', currentUser);
    console.log('AdminRoute - Is Admin:', isAdmin());
    
    if (!token) {
        console.log('AdminRoute - No token, redirecting to login');
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin()) {
        console.log('AdminRoute - User is not admin, redirecting to dashboard');
        return <Navigate to="/dashboard" replace />;
    }

    console.log('AdminRoute - Admin access granted, rendering admin panel');
    return children;
};

export default AdminRoute;
